export const businessEntityKeys = {
  FETCH_BUSINESS_ENTITY: 'FETCH_BUSINESS_ENTITY',
  FETCH_BUSINESS_ENTITIES_OF_COMPANY: 'FETCH_BUSINESS_ENTITIES_OF_COMPANY',
  FETCH_COMPANY_ORG_STRUCTURE: 'FETCH_COMPANY_ORG_STRUCTURE',
  FETCH_SUPPORTED_JURISDICTIONS: 'FETCH_SUPPORTED_JURISDICTIONS',
  FETCH_SUPPORTED_ENTITY_TYPES: 'FETCH_SUPPORTED_ENTITY_TYPES',
  FETCH_ALL_JURISDICTIONS: 'FETCH_ALL_JURISDICTIONS',
};
